import { TargetEnv, targetEnv } from '~/config';

export const LOCAL_STORAGE_EMAIL_KEY = 'digisme-email';

export const QBE_HOME_LINK = 'https://www.qbe.com/au';
export const POLICY_WORDING_LINK =
  'https://www.qbe.com/au/business-insurance/small-business/small-business-insurance-policy-documents';
export const TNC_LINK = 'https://www.qbe.com/au/about/governance/website-terms';
export const PRIVACY_LINK = 'https://www.qbe.com/au/about/governance/privacy-policy';
